/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

const capitalizeAfterSpace = (str) => {
  const words = str.split(" ");
  for (let i = 0; i < words.length; i++) {
    words[i] = words[i].charAt(0).toUpperCase() + words[i].slice(1);
  }
  const capitalizedStr = words.join(" ");

  return capitalizedStr;
};

export default capitalizeAfterSpace;
